import { gql } from '@apollo/client';

const GET_CHANNELS_QUERY = gql`
  query GetAccount {
    account {
      currentOrganization {
        id
        channels(product: publish) {
          id
          name
          service
          avatar
          serverUrl
          locationData {
            location
          }
        }
      }
    }
  }
`;

const CHANNELS = [
  {
    id: 'id1',
    name: 'buffer.facebook',
    service: 'facebook',
    avatar: 'https://fake-img.jpg',
    serverUrl: null,
    locationData: null,
  },
  {
    id: '62b024d6d477f60c13b4574e',
    name: 'Facebook Test',
    service: 'facebook',
    avatar: 'https://fake-img.jpg',
    serverUrl: null,
    locationData: null,
  },
  {
    id: 'id2',
    name: 'buffer.ig',
    service: 'instagram',
    avatar: 'https://fake-img.jpg',
    serverUrl: null,
    locationData: null,
  },
];

export function mocks(numberOfChannels = 3) {
  const channels = CHANNELS.slice(0, numberOfChannels);
  return [
    {
      request: {
        query: GET_CHANNELS_QUERY,
        variables: {},
      },
      result: {
        data: {
          account: {
            currentOrganization: {
              id: '609ef21bd1b7e00848d6c408',
              channels,
            },
          },
        },
      },
    },
  ];
}

export default GET_CHANNELS_QUERY;
